import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.connectBankAccount.FailPage', {
    title: 'Connect Bank Account | Fail',
    learnMore: 'Learn more',
    unableToEstablish: 'Connection failed',
    thereWasAnIssue: 'Unable to connect to your bank account.',
    tryAgain: 'Try again',
    contactSupport: 'Contact Support',
    areYouSure: 'Are you sure you want to close this window?',
    yes: 'Yes, Close It',
});
